// Theme: midnight-city
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'midnight-city',
  name: 'MIDNIGHT CITY',
  tagline: 'MIDNIGHT CITY',
  description: 'Metropole azul meia-noite com profundidade e ruido suave.',
  category: 'urban-expression',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#080810', '#1D4ED8', '#10102A', '#DBEAFE'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)'
    },
    shellClasses: 'font-sans theme-midnight-city'
  },
  colorVars: {
    '--accent': '#1D4ED8',
    '--accent-foreground': '#080810',
    '--background': '#080810',
    '--border': '#2A2A5A',
    '--card': '#10102A',
    '--card-border-active': 'rgba(29, 78, 216, 0.48)',
    '--card-completed': '#10102A',
    '--card-foreground': '#DBEAFE',
    '--card-glow': 'rgba(29, 78, 216, 0.1)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#080810',
    '--foreground': '#DBEAFE',
    '--hold-fill': '#1D4ED8',
    '--input': '#10102A',
    '--modal-bg': '#080810',
    '--modal-border': '#2A2A5A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A2A5A',
    '--muted-foreground': '#DBEAFE',
    '--nav-active': '#1D4ED8',
    '--nav-bg': '#080810',
    '--popover': '#10102A',
    '--popover-foreground': '#DBEAFE',
    '--primary': '#1D4ED8',
    '--primary-foreground': '#080810',
    '--ring': '#1D4ED8',
    '--secondary': '#2A2A5A',
    '--secondary-foreground': '#DBEAFE',
    '--streak': '#1D4ED8',
    '--success': '#22C55E',
    '--success-foreground': '#080810',
    '--xp': '#1D4ED8',
    '--xp-bg': '#10102A'
  },
  resolvedVars: {
    '--accent': '#1D4ED8',
    '--accent-foreground': '#080810',
    '--accent-foreground-hsl': '240 33% 5%',
    '--accent-foreground-oklch': 'from #080810 l c h',
    '--accent-hsl': '224 76% 48%',
    '--accent-oklch': 'from #1D4ED8 l c h',
    '--background': '#080810',
    '--background-hsl': '240 33% 5%',
    '--background-oklch': 'from #080810 l c h',
    '--border': '#2A2A5A',
    '--border-hsl': '240 36% 26%',
    '--border-oklch': 'from #2A2A5A l c h',
    '--border-w': '1px',
    '--card': '#10102A',
    '--card-border-active': 'rgba(29, 78, 216, 0.48)',
    '--card-completed': '#10102A',
    '--card-completed-hsl': '240 45% 11%',
    '--card-completed-oklch': 'from #10102A l c h',
    '--card-foreground': '#DBEAFE',
    '--card-foreground-hsl': '214 95% 93%',
    '--card-foreground-oklch': 'from #DBEAFE l c h',
    '--card-glow': 'rgba(29, 78, 216, 0.1)',
    '--card-hsl': '240 45% 11%',
    '--card-oklch': 'from #10102A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#080810',
    '--destructive-foreground-hsl': '240 33% 5%',
    '--destructive-foreground-oklch': 'from #080810 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#DBEAFE',
    '--foreground-hsl': '214 95% 93%',
    '--foreground-oklch': 'from #DBEAFE l c h',
    '--hold-fill': '#1D4ED8',
    '--hold-fill-hsl': '224 76% 48%',
    '--hold-fill-oklch': 'from #1D4ED8 l c h',
    '--input': '#10102A',
    '--input-hsl': '240 45% 11%',
    '--input-oklch': 'from #10102A l c h',
    '--modal-bg': '#080810',
    '--modal-bg-hsl': '240 33% 5%',
    '--modal-bg-oklch': 'from #080810 l c h',
    '--modal-border': '#2A2A5A',
    '--modal-border-hsl': '240 36% 26%',
    '--modal-border-oklch': 'from #2A2A5A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A2A5A',
    '--muted-foreground': '#DBEAFE',
    '--muted-foreground-hsl': '214 95% 93%',
    '--muted-foreground-oklch': 'from #DBEAFE l c h',
    '--muted-hsl': '240 36% 26%',
    '--muted-oklch': 'from #2A2A5A l c h',
    '--nav-active': '#1D4ED8',
    '--nav-active-hsl': '224 76% 48%',
    '--nav-active-oklch': 'from #1D4ED8 l c h',
    '--nav-bg': '#080810',
    '--nav-bg-hsl': '240 33% 5%',
    '--nav-bg-oklch': 'from #080810 l c h',
    '--popover': '#10102A',
    '--popover-foreground': '#DBEAFE',
    '--popover-foreground-hsl': '214 95% 93%',
    '--popover-foreground-oklch': 'from #DBEAFE l c h',
    '--popover-hsl': '240 45% 11%',
    '--popover-oklch': 'from #10102A l c h',
    '--primary': '#1D4ED8',
    '--primary-foreground': '#080810',
    '--primary-foreground-hsl': '240 33% 5%',
    '--primary-foreground-oklch': 'from #080810 l c h',
    '--primary-hsl': '224 76% 48%',
    '--primary-oklch': 'from #1D4ED8 l c h',
    '--radius': '12px',
    '--ring': '#1D4ED8',
    '--ring-hsl': '224 76% 48%',
    '--ring-oklch': 'from #1D4ED8 l c h',
    '--secondary': '#2A2A5A',
    '--secondary-foreground': '#DBEAFE',
    '--secondary-foreground-hsl': '214 95% 93%',
    '--secondary-foreground-oklch': 'from #DBEAFE l c h',
    '--secondary-hsl': '240 36% 26%',
    '--secondary-oklch': 'from #2A2A5A l c h',
    '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--streak': '#1D4ED8',
    '--streak-hsl': '224 76% 48%',
    '--streak-oklch': 'from #1D4ED8 l c h',
    '--success': '#22C55E',
    '--success-foreground': '#080810',
    '--success-foreground-hsl': '240 33% 5%',
    '--success-foreground-oklch': 'from #080810 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(224 76% 48% / 0.15)',
    '--xp': '#1D4ED8',
    '--xp-bg': '#10102A',
    '--xp-bg-hsl': '240 45% 11%',
    '--xp-bg-oklch': 'from #10102A l c h',
    '--xp-hsl': '224 76% 48%',
    '--xp-oklch': 'from #1D4ED8 l c h'
  }
}
